'use client';
import React from 'react';

const PostsByActivity = () => {
  return <div></div>;
};

export default PostsByActivity;
